/* eslint-disable prettier/prettier */
import { v4 as uuidV4 } from "uuid";

export const QUERY = {
  all: `
  query MyQuery {
    allAgents(condition: {isActive: true}) {
      nodes {
        id
        value:id
        label:firstName
        firstName
        lastName
        company
        email
        address
        mobile
      }
    }
  }
  
  
    `,
  add: ({ firstName, lastName, company, email, address, mobile }) => `
  mutation MyMutation {
    createAgent(
      input: {
        agent: {
          id: "${uuidV4()}"
          firstName: "${firstName}"
          lastName: "${lastName}"
          company: "${company}"
          email: "${email}"
          address: "${address}"
          mobile: "${mobile}"
          createdAt: "${new Date().toISOString()}"
          updatedAt: "${new Date().toISOString()}"
          isActive: true
        }
      }
    ){
      clientMutationId
    }
  }
    `,
  update: ({ id, isActive = true, firstName, lastName, company, email, address, mobile }) => `
  mutation MyMutation {
    updateAgentById(
      input: {
        agentPatch: {
          ${firstName ? `firstName: "${firstName}"`:``}
          ${lastName ? `lastName: "${lastName}"`:``}
          ${company ? `company: "${company}"`:``}
          ${email ? `email: "${email}"`:``}
          ${address ? `address: "${address}"`:``}
          ${mobile ? `mobile: "${mobile}"`:``}
          updatedAt: "${new Date().toISOString()}"
          isActive: ${isActive}
        }
        id: "${id}"
      }
    ) {
      clientMutationId
    }
  }`
};